// Real Data for Janica Cabidoy - Web3 Community Manager Portfolio

export const personalInfo = {
  name: "Janica Cabidoy",
  title: "Community Manager",
  subtitle: "Virtual Assistant | Content Developer | Social Media Manager",
  location: "Cainta, Rizal, Philippines",
  email: "jcabidoy147@gmail.com",
  phone: "09560819264",
  linkedin: "https://www.linkedin.com/in/janicacabidoynicseuu/",
  telegram: "@Nicseuuuu",
  telegramUrl: "https://t.me/Nicseuuuu",
  calendly: "https://calendly.com/jcabidoy147",
  resumeUrl: "/Janica_Cabidoy_Resume.pdf",
  profileImages: [
    "https://customer-assets.emergentagent.com/job_engagement-expert-1/artifacts/58fa79t2_telegram-cloud-photo-size-5-6330176440598465945-y.jpg",
    "https://customer-assets.emergentagent.com/job_engagement-expert-1/artifacts/dfnrxt8g_unnamed.jpg"
  ],
  badges: [
    "163% Community Growth",
    "95K+ Members Managed",
    "Web3 Expert"
  ],
  baseRate: "1,200 USDT/month",
  availability: {
    status: "Available for Hire",
    responseTime: "Within 24 hours",
    timezone: "UTC+8 (Philippines)"
  }
};

export const metrics = [
  {
    id: 1,
    value: "163%",
    label: "Community Growth",
    description: "in 5 months",
    detail: "From 36,000 to 95,000 members"
  },
  {
    id: 3,
    value: "75K+",
    label: "Telegram Members",
    description: "managed daily",
    detail: "Moderation, announcements, support"
  },
  {
    id: 4,
    value: "20K+",
    label: "Discord Members",
    description: "active community",
    detail: "Daily engagement & growth"
  },
  {
    id: 5,
    value: "60%",
    label: "Spam Reduction",
    description: "using filters",
    detail: "Bot activity & spam eliminated"
  },
  {
    id: 6,
    value: "3.9%",
    label: "Campaign CTR",
    description: "above average",
    detail: "Tracked links & clear CTAs"
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Facebook Page Growth Campaign",
    client: "Crypto Education Platform",
    duration: "28 Days Initial + 90 Days Total",
    challenge: "The page started with low engagement and inconsistent reach due to unstructured posting.",
    solution: "Planned a focused crypto content campaign built around daily educational posts, short crypto news updates, and simple giveaway mechanics to drive interaction. Content followed repeatable formats with strong hooks and clear CTAs, posted consistently and timed around market activity.",
    results: {
      initial: {
        period: "28 Days",
        reach: "1.1M",
        reachGrowth: "277%",
        videoViews: "3.5M",
        oneMinuteViews: "459K",
        interactions: "206K",
        nonFollowerReach: "1M+"
      },
      extended: {
        period: "90 Days",
        reach: "1.6M",
        reachGrowth: "158%",
        videoViews: "4.3M",
        oneMinuteViews: "588K",
        watchTime: "1,932 days",
        interactions: "314K"
      }
    },
    images: [
      "https://customer-assets.emergentagent.com/job_d54afb45-b549-460a-a8cf-d9861c8cf38d/artifacts/o082lzxl_54.png",
      "https://customer-assets.emergentagent.com/job_d54afb45-b549-460a-a8cf-d9861c8cf38d/artifacts/lusohmb9_53.png"
    ],
    tags: ["Social Media", "Content Strategy", "Growth"]
  },
  {
    id: 2,
    title: "NODO Vaults Update Automation",
    client: "NODO DeFi Protocol",
    duration: "Ongoing",
    challenge: "Manual updates to community about vault performance were time-consuming and often delayed.",
    solution: "Designed a custom AI system that sends real-time vault updates to the community, tracking performance across multiple cryptocurrency vaults (Momentum Vaults and Cetus Vault).",
    results: {
      features: [
        "Automated performance tracking",
        "Real-time APY and TVL monitoring",
        "Instant community notifications",
        "24/7 operation without manual intervention"
      ]
    },
    images: [
      "/nodo-deposit-alert.png"
    ],
    tags: ["Automation", "DeFi", "AI Bot"]
  },
  {
    id: 3,
    title: "NODO Deposit Alert System",
    client: "NODO DeFi Protocol",
    duration: "Ongoing",
    challenge: "Community lacked transparency into real-time deposit activities and protocol momentum.",
    solution: "Built an intelligent notification system that alerts the community about new deposits in real-time, showcasing transparency and momentum.",
    results: {
      features: [
        "Instant deposit notifications",
        "Detailed financial metrics display",
        "Amount, APY, TVL tracking",
        "Enhanced community trust"
      ]
    },
    images: [
      "/nodo-vaults-update.jpeg"
    ],
    tags: ["Automation", "Transparency", "AI Bot"]
  }
];

export const faqData = [
  {
    id: 1,
    question: "Are you available for freelance?",
    answer: "Yes, I am currently available for freelance work. I specialize in taking on projects that require a strategic blend of community growth, E-commerce scaling, and technical automation."
  },
  {
    id: 2,
    question: "What's your rate?",
    answer: "My base rate is **1,200 USDT per month**. Final pricing may vary depending on the scope of work and the complexity of additional technical builds or custom automation requirements."
  },
  {
    id: 3,
    question: "What tools do you use?",
    answer: "I utilize a comprehensive tech stack:\n\n**Community & Social:** Galxe, Buffer, Hootsuite, Sprout Social, Guild.xyz for community management and social scheduling.\n\n**Support & Forms:** Zendesk for customer support, Typeform for forms and surveys, Zoom for meetings.\n\n**Analytics & Data:** Dune for on-chain analytics, Google Analytics for web metrics.\n\n**Productivity:** Google Calendar, Google Drive, Google Docs, Google Sheets for organization.\n\n**Design & Content:** Canva, CapCut, and Photoshop for creating visually appealing content."
  },
  {
    id: 4,
    question: "Do you build custom AI automation bots?",
    answer: "Yes! I design and deploy customizable AI systems to monitor, grow, and engage communities **24/7**. These bots handle everything from activity tracking to smart scheduling, real-time notifications, and performance monitoring."
  }
];

export const skills = [
  { name: "Community Management", level: 95 },
  { name: "Customer Service", level: 95 },
  { name: "Content Strategy & Development", level: 90 },
  { name: "Discord/Telegram Moderation", level: 92 },
  { name: "AI Automation (Make.com, GHL, Custom Bots)", level: 85 },
  { name: "Social Media Marketing", level: 88 },
  { name: "Web3/DeFi Knowledge", level: 90 },
  { name: "Graphic Design (Canva, Photoshop)", level: 85 },
  { name: "Video Editing (CapCut, Premiere Pro)", level: 82 }
];

export const experience = [
  {
    id: 1,
    role: "Social Media Marketing",
    company: "KCW Plastic Corporation",
    period: "September 2024 - Present",
    description: "Developed and executed social media strategies to boost brand visibility and engagement. Created and scheduled engaging content, including graphics and videos, for multiple platforms. Monitored social media metrics to assess and improve campaign effectiveness.",
    highlights: ["Strategy execution", "Content creation", "Community building", "Cross-platform management"]
  },
  {
    id: 2,
    role: "Community Manager",
    company: "NODO",
    period: "August 2024 - January 2026",
    description: "Develop and implement social media strategies to increase brand awareness and engagement within the community. Design visually compelling graphics and promotional materials aligned with NODO's brand and campaign objectives. Manage and schedule posts across various social media platforms.",
    highlights: ["Brand awareness", "Community engagement", "Video content creation", "Analytics optimization"]
  },
  {
    id: 3,
    role: "Crypto Community Manager",
    company: "BITLINKEXC",
    period: "August 2023 - June 2024",
    description: "Managed and grew online communities across platforms like Discord and Telegram. Developed and executed community engagement strategies, including AMAs, events, and content creation.",
    highlights: ["Community growth", "AMAs & Events", "Crisis management", "Cross-functional collaboration"]
  },
  {
    id: 4,
    role: "Social Media Manager",
    company: "FIDEM (TikTok & FB Influencer)",
    period: "July 2021 - March 2024",
    description: "Managed and moderated online communities, fostering engagement and interaction among members. Analyzed social media performance and user engagement to optimize content strategies.",
    highlights: ["1.6M+ reach", "4.3M video views", "314K interactions", "Brand management"]
  },
  {
    id: 5,
    role: "Content Developer",
    company: "Tech Factors Inc.",
    period: "2019 - March 2024",
    description: "Designed and developed engaging educational materials, including lesson plans, presentations, and multimedia content for Mathematics subjects for K-10 grade levels.",
    highlights: ["Educational content", "Multimedia production", "K-10 curriculum", "Training & support"]
  }
];

export const education = {
  degree: "Bachelor of Secondary Education",
  major: "Mathematics",
  institution: "Pamantasan ng Lungsod ng Pasig",
  period: "2015 - 2019"
};

export const whyHireMe = [
  {
    icon: "TrendingUp",
    title: "Proven Growth Results",
    description: "163% community growth in 5 months with documented metrics and case studies."
  },
  {
    icon: "Bot",
    title: "AI Automation Expert",
    description: "Custom bots that work 24/7 to engage, monitor, and grow your community."
  },
  {
    icon: "Users",
    title: "Large-Scale Management",
    description: "Experience managing 95K+ members across Telegram and Discord."
  },
  {
    icon: "Zap",
    title: "Fast Response Time",
    description: "Available within 24 hours with dedicated support and communication."
  },
  {
    icon: "Shield",
    title: "Spam & Bot Protection",
    description: "60% reduction in spam using advanced filters and manual review."
  },
  {
    icon: "BarChart3",
    title: "Data-Driven Approach",
    description: "Every decision backed by analytics, tracking, and measurable KPIs."
  }
];

export const tools = [
  "Galxe",
  "Buffer",
  "Hootsuite",
  "Sprout Social",
  "Zendesk",
  "Typeform",
  "Zoom",
  "Dune",
  "Guild.xyz",
  "Google Calendar",
  "Google Drive",
  "Google Docs",
  "Google Sheets",
  "Google Analytics",
  "Canva",
  "CapCut",
  "Photoshop"
];

export const linkedInPosts = [
  {
    id: 1,
    content: "I love solving problems that save people time and energy. Recently built an automation system that handles community updates 24/7...",
    date: "July 2024",
    likes: 127,
    comments: 23,
    url: "https://www.linkedin.com/posts/janicacabidoynicseuu_i-love-solving-problems-that-save-people-activity-7422084775923986432-6BIe"
  }
];

export const projectCategories = [
  "All",
  "Community Management",
  "AI Automation",
  "Social Media",
  "Content Strategy"
];
